var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDmmIcon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_140",
    "data-name": "Group 140",
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.327,
    height: 101.668,
    viewBox: "0 0 121.327 101.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 120.691,
    height: 22.824,
    transform: "translate(0.318 0.318)",
    fill: "#293d87"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 120.691,
    height: 11.173,
    transform: "translate(0.318 23.142)",
    fill: "#26c778"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 120.691,
    height: 11.173,
    transform: "translate(0.318 34.315)",
    fill: "#26c778"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 120.691,
    height: 11.173,
    transform: "translate(0.318 45.487)",
    fill: "#26c778"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 120.691,
    height: 11.173,
    transform: "translate(0.318 56.66)",
    fill: "#26c778"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 120.691,
    height: 11.173,
    transform: "translate(0.318 67.832)",
    fill: "#26c778"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 120.691,
    height: 11.173,
    transform: "translate(0.318 79.005)",
    fill: "#26c778"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 120.691,
    height: 11.173,
    transform: "translate(0.318 90.178)",
    fill: "#26c778"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M.635,214.7H120.691v10.537H.635ZM0,225.874H121.327V214.066H0Z",
    transform: "translate(0 -180.069)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M.635,285.051H120.691v10.537H.635ZM0,296.224H121.327V284.416H0Z",
    transform: "translate(0 -239.246)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M.635,355.4H120.691v10.537H.635ZM0,366.574H121.327V354.766H0Z",
    transform: "translate(0 -298.424)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M.635,425.75H120.691v10.537H.635ZM0,436.923H121.327V425.115H0Z",
    transform: "translate(0 -357.6)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M.635,496.1H120.691v10.537H.635ZM0,507.273H121.327V495.465H0Z",
    transform: "translate(0 -416.778)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M.635,566.449H120.691v10.537H.635ZM0,577.622H121.327V565.814H0Z",
    transform: "translate(0 -475.954)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M.635.635H120.691V22.824H.635ZM0,23.46H121.327V0H0Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M.635,144.352H120.691V154.89H.635ZM0,155.525H121.327V143.717H0Z",
    transform: "translate(0 -120.893)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 32.678,
    height: 1.889,
    transform: "translate(9.465 7.585)",
    fill: "#fff"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 22.215,
    height: 1.889,
    transform: "translate(9.465 13.986)",
    fill: "#fff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 12.376,
    height: 1.889,
    transform: "translate(9.465 10.785)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 16.289,
    height: 1.889,
    transform: "translate(23.535 10.785)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmmIcon02);
export default __webpack_public_path__ + "static/media/DMM_icon02.7f5e70c9b677e867635029db660acbcd.svg";
export { ForwardRef as ReactComponent };